// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";


const firebaseConfig = {
    apiKey: "AIzaSyBdqo4xU7zABlAWhlJed5ks6z2hXdgItUA",
    authDomain: "rastromais-7kbpxd.firebaseapp.com",
    projectId: "rastromais-7kbpxd",
    storageBucket: "rastromais-7kbpxd.firebasestorage.app",
    messagingSenderId: "725304661850",
    appId: "1:725304661850:web:8c42322e3052f31f2fc563"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);


export const Firebase = app;
export const Analytics = analytics;
